Ext.ns('mx.comp');

mx.comp.Swf = Ext.extend(Ext.Panel, {
    layout: 'fit',
    tpl: new Ext.XTemplate(
        '<script type="text/javascript">' +
            'swfobject.registerObject("{objectId}", "{flashPluginVersion}", "{pathToExpressInstallSwf}");' +
            '</script>' +
            '<object classid="{classid}" width="100%" height="100%" id="{objectId}">\n' +
            '<param name="movie" value="{movie}"/>\n' +
            '<param name="wmode" value="transparent"/>' +
            '<param name="allowscriptaccess" value="always"/>' +
            '<!--[if !IE]>-->' +
            '<object type="application/x-shockwave-flash" data="{movie}" width="100%" height="100%" id="{objectId}">' +
            '<!--<![endif]-->' +
            '<param name="flashvars" value=\'{flashvars}\' />' +
            '<param name="wmode" value="transparent" />' +
            '<a href="http://www.adobe.com/go/getflashplayer">' +
            '<img src="http://www.adobe.com/images/shared/download_buttons/get_flash_player.gif" alt="Get Adobe Flash player">' +
            '</a>' +
            '<!--[if !IE]>-->' +
            '</object>' +
            '<!--<![endif]-->' +
            '</object>'
    ),

    afterRender: function() {
        mx.comp.Swf.superclass.afterRender.apply(this, arguments);
        this.tpl.overwrite(this.body, this);
    },
});

Ext.reg('mx_swf', mx.comp.Swf);
